import { inject, Injectable, DOCUMENT } from '@angular/core';
import { Keyboard } from '@capacitor/keyboard';
import { CapacitorService } from '@libs/shared/common';

@Injectable({
  providedIn: 'root',
})
export class VirtualKeyboardService {

  private readonly document: Document = inject(DOCUMENT);
  private readonly capacitorService: CapacitorService = inject(CapacitorService);

  public async hide(): Promise<void> {
    if (this.capacitorService.isCapacitorApp()) {
      await Keyboard.hide();

      return;
    }

    if (this.document.activeElement?.tagName === 'INPUT') {
      (this.document.activeElement as HTMLInputElement).blur();
    }
  }
}
